import React from "react";
import { UserPlus, Play, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const steps = [{
  number: "01",
  title: "TALK",
  description: "Speak naturally. PocketPal captures your space requirements in seconds.",
  icon: UserPlus
}, {
  number: "02",
  title: "MATCH",
  description: "We connect you with the right broker in your market. Specialized, local, vetted.",
  icon: Play
}, {
  number: "03",
  title: "TOUR & CLOSE",
  description: "Your broker shows you the right spaces. You sign. Always free.",
  icon: TrendingUp
}];
export default function TheThreeStepPath() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="44844" id="the-tenant-journey" ref={ref} className={cn("dark bg-[#0D1B2A] text-white py-24 relative overflow-hidden", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10", "transition-all duration-700 ease-out")}>
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
          <h2 className="font-sans text-4xl md:text-7xl font-black mb-4 leading-none uppercase tracking-tighter">
            <span className="text-white">THE TENANT </span>
            <span className="text-[#3CC5F3]">JOURNEY</span>
          </h2>
          <p className="text-[#3CC5F3] font-bold text-lg md:text-xl uppercase tracking-widest">
            Fast. Efficient. Elite.
          </p>
        </div>

        {}
        <div className="relative">
          {}
          <div className="hidden md:block absolute top-8 left-[16.66%] right-[16.66%] h-[6px] bg-[#3CC5F3] shadow-[0_0_15px_rgba(60,197,243,0.5)] z-0" aria-hidden="true" />

          {}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative z-10">
            {steps.map((step, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                {}
                <div className="relative mb-6">
                  <div className="w-20 h-20 rounded-full border-4 border-[#3CC5F3] bg-[#0D1B2A] flex items-center justify-center shadow-[0_0_25px_-5px_#3CC5F3] transition-all duration-300 group-hover:scale-110 group-hover:shadow-[0_0_35px_-5px_#3CC5F3]">
                    <step.icon className="w-10 h-10 text-[#3CC5F3]" strokeWidth={2.5} />
                  </div>
                  
                  {}
                  {i !== steps.length - 1 && <div className="md:hidden absolute top-20 left-1/2 -translate-x-1/2 w-[6px] h-12 bg-[#3CC5F3] shadow-[0_0_15px_rgba(60,197,243,0.3)]" />}
                </div>

                {}
                <div className="space-y-3 max-w-xs mx-auto">
                  <span className="text-base font-black text-[#FCB231] tracking-widest block">
                    {step.number}
                  </span>
                  <h3 className="text-2xl font-black text-white font-sans uppercase tracking-tight">
                    {step.title}
                  </h3>
                  <p className="text-gray-400 font-medium leading-tight">
                    {step.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-[#3CC5F3] to-transparent animate-pulse" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-[#3CC5F3] to-transparent animate-pulse delay-700" />
      </div>
    </section>;
}